import { RootState } from "../store"
export const wishItemsSelector = (store:RootState) => store.wishSlice;